// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aSR0","footer":"styles_footer__2Q-Ow"};